import { fetchBase } from "./fetchBase";
import axios, { APP_BASE_URL } from "../api/axios";
import { useMutatePrivate } from "../hooks/useFetchPrivate";

const DEFAULTS = {
  organization_id: "0a98c0a8-dcf5-4fef-abf3-d896ac540e77",
  ttl: 3600,
};

export const signUpApi = async ({
  email,
  password,
  confirmPassword,
  firstName,
  lastName,
  dob,
  phone,
  organization_id = DEFAULTS.organization_id,
}) => {
  const data = {
    email,
    password,
    password_confirmation: confirmPassword,
    first_name: firstName,
    last_name: lastName,
    dob,
    phone,
    organization_id,
  };
  return await fetchBase({ url: "auth/register", method: "post", data });
};

export const signInApi = async ({
  email,
  password,
  checkAdmin = true,
  ttl = DEFAULTS.ttl,
  organization_id = DEFAULTS.organization_id,
}) => {
  const data = {
    email,
    password,
    checkAdmin,
    ttl,
    organization_id,
  };
  return await fetchBase({ url: "auth/local", method: "post", data });
};

export const forgotPasswordApi = async ({ email }) => {
  const data = {
    email,
    destination: `${APP_BASE_URL}/auth/resetpassword`,
  };
  return await fetchBase({ url: "auth/sendpasswordreset", method: "post", data });
};

export const resetPasswordApi = async ({ newPassword, confirmPassword, token }) => {
  const data = {
    key: token,
    password: newPassword,
    password_confirmation: confirmPassword,
  };
  return await fetchBase({ url: "auth/resetpassword", method: "post", data }).catch(
    (error) => ({
      error: error.apiError || { message: error.message },
    }),
  );
};

export const refreshTokenApi = async (tokenOrFn, signal) => {
  let tries = 3;
  let lastError = null;
  while (tries-- > 0) {
    try {
      const token = typeof tokenOrFn === "function" ? tokenOrFn() : tokenOrFn;
      const { data } = await axios.get("/auth/refreshtoken", {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
        signal,
      });
      return { data };
    } catch (error) {
      lastError = error;
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
  }
  throw lastError;
};

export const useUserResetPasswordApi = ({ useMutateOptions } = {}) => {
  const { mutate, ...rest } = useMutatePrivate(
    { method: "post", url: "/auth/passwordreset" },
    useMutateOptions,
  );
  return {
    mutate: ({ password, newPassword, newPassConfirm }) =>
      mutate({
        data: {
          current_password: password,
          new_password: newPassword,
          new_password_confirmation: newPassConfirm,
        },
      }),
    ...rest,
  };
};
